import { getDefaultSignupDateRangeIso } from "@/utils/defaultSignupDateRange";

const defaultRange = getDefaultSignupDateRangeIso();

export const namespaced = true;

/* The Disbursement screen's filters, kept here so they survive leaving the
   screen. Every key below is both written by a control and sent in the request;
   display_from_daterange, selected_tab, from_date_range and display_daterange
   are gone, having been left behind by the v-tabs and hand-rolled date field the
   rewrite replaced -- three were never read or written at all. */
export const state = {
    date_range: defaultRange,
    /* Applied On, as on Leads. Empty by default: the ledger opens on its
       disbursal window, as it always has. */
    applied_range: [],
    page_number: 1,
    product_type: "",
    product: "",
    utm_source: [],
    utm_medium: [],
    utm_content: [],
    utm_campaign: [],
    utm_term: [],
    utm_platform: [],
    /* all | matched | unmatched: offers, lender-reported rows with no offer, or both */
    match_state: "all",
};
export const getters = {
    getFilters: (state) => {
        return state;
    },
};